import "./TermsAndConditions.css";
import React, { useEffect, useState } from "react";
import { useConfigs } from "./components/ConfigsContext";
import ReactHtmlParser from "html-react-parser";

const RechargePolicy = () => {
  const { loading, error, data } = useConfigs();
  const [rechargePolicyData, setRechargePolicyData] = useState([]);

  useEffect(() => {
    if (data) {
      const contentData = data.rechargeTAndC.data;
      setRechargePolicyData(contentData);
    }
  }, [data]);

  return (
    <div className="terms-container">
        {loading ? (
            <div className="center">Loading...</div>
          ) : error ? (
            <div>Error: {error.message}</div>
          ) : ( rechargePolicyData.length !== 0 && (
        <div>
          <div className="terms_heading">
            <h2>{rechargePolicyData.attributes.title}</h2>
          </div>
          <div className="terms-content">
            {ReactHtmlParser(rechargePolicyData.attributes.content)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default RechargePolicy;
